import "./index.scss";
import { FormGroup, TextField, Button, Checkbox } from "@mui/material";
import { patch, post, register } from "../../utils/api";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GoogleIcon from "../../layout/assets/images/Login/google-icon.png";
import DelnieLogoIcon from "../../layout/assets/images/Login/delnie-logo.svg";
import LoginRegisterBanner from "../../layout/assets/images/Login/login-register-banner.svg";
import SnackbarAlert from "../common/sanckbar";

function ClientUserRegister() {
  const navigate = useNavigate();
  const [regData, setRegData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
  });

  const [errorState, setErrorState] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
  });

  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");

  const handlePost = async (e: any) => {
    e.preventDefault();

    const response = await post("client_users", {
      first_name: regData.first_name,
      last_name: regData.last_name,
      username: regData.username,
      email: regData.email,
      password: regData.password,
      full_name : regData.first_name+" "+regData.last_name,
    });
    if (response) {
      console.log("resooooo",response )
      // alert(response.message ? response.message : "success", "success");
      setTimeout(() => navigate("/login"), 2000);
    } else {
      alert(response.message, "warning");
    }
  };

  const validateForm = () => {
    const newErrorState = { ...errorState };

    if (!regData.email) {
      newErrorState.email = 'Email is required  className="reg-input"';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(regData.email)
    ) {
      newErrorState.email = "Invalid email address";
    } else {
      newErrorState.email = "";
    }
    if (!regData.username) {
      newErrorState.first_name =
        'Username is required  className="reg-input"';
    } else {
      newErrorState.first_name = "";
    }
    if (!regData.first_name) {
      newErrorState.first_name =
        'First name is required  className="reg-input"';
    } else {
      newErrorState.first_name = "";
    }

    if (!regData.last_name) {
      newErrorState.last_name = 'Last name is required  className="reg-input"';
    } else {
      newErrorState.last_name = "";
    }

    if (!regData.password) {
      newErrorState.password = 'Password is required  className="reg-input"';
    } else {
      newErrorState.password = "";
    }

    setErrorState(newErrorState);

    return Object.values(newErrorState).every((error) => error === "");
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setRegData({
      ...regData,
      [name]: value,
    });
  };

  const alert = (message: string, alert_severity: string = "warning") => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
    console.log("snackbar", snackbar);
    console.log("message", message);
    console.log("alertSeverity", alert_severity);
  };

  const closeSnackbar = () => {
    setSnackbar(false);
  };

  return (
    <>
      <SnackbarAlert
        open={snackbar}
        closeSnackbar={closeSnackbar}
        message={alert_message}
        severity={alert_severity}
      />
      <div className="row register">
        <div className="col-lg-6 col-md-6 col-xs-12 lft-cntnr">
          <img src={LoginRegisterBanner} alt="" className="w-100" />
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 right-cntnr text-center register-right-section">
          {/* <img src={DelnieLogoIcon} className="logo" alt="logo" /> */}
          <span className="company-name-first-part"> Nautai-Marine - Client Registration </span>{" "}
          {/* <span className="company-name-second-part">
            {" "}
            - Delnie Cloud Admin
          </span> */}
          <h1 className="heading login-heading">Sign Up</h1>
          <form className="form" onSubmit={handlePost}>
            <FormGroup className="register-formgroup">
              <TextField
                label="First Name"
                required
                className="reg-input name-field"
                name="first_name"
                value={regData.first_name}
                onChange={handleChange}
                error={Boolean(errorState.first_name)}
                helperText={errorState.first_name}
              />
            </FormGroup>
            <FormGroup className="register-formgroup">
              <TextField
                label="Last Name"
                required
                className="reg-input name-field"
                name="last_name"
                value={regData.last_name}
                onChange={handleChange}
                error={Boolean(errorState.last_name)}
                helperText={errorState.last_name}
              />
            </FormGroup>
            <FormGroup className="register-formgroup">
              <TextField
                label="User Name"
                required
                className="reg-input name-field"
                name="username"
                value={regData.username}
                onChange={handleChange}
                error={Boolean(errorState.username)}
                helperText={errorState.username}
              />
            </FormGroup>
            <FormGroup className="register-formgroup">
              <TextField
                label="Email"
                type="email"
                required
                className="reg-input email-field"
                name="email"
                value={regData.email}
                onChange={handleChange}
                error={Boolean(errorState.email)}
                helperText={errorState.email}
              />
            </FormGroup>
            <FormGroup className="register-formgroup">
              <TextField
                label="Password"
                type="password"
                required
                className="reg-input password-field"
                name="password"
                value={regData.password}
                onChange={handleChange}
                error={Boolean(errorState.password)}
                helperText={errorState.password}
              />
            </FormGroup>
            {/* <FormGroup>
            <TextField
              label="Organization / Company / Business Name"
              required
              className="reg-input org-field"
              name="organization"
              value={regData.organization}
              onChange={handleChange}
            />
          </FormGroup> */}
            <div className="d-flex justify-content-start align-items-center conditions-check-container">
              {/* <Checkbox
                value="checkedA"
                inputProps={{
                  "aria-label": "Checkbox A",
                }}
                sx={{
                  borderWidth: "0.5px",
                }}
              /> */}
              {/* <span>I agree to Delnie’s terms and conditions</span> */}
            </div>
            <FormGroup className="rgstr-btn text-center d-flex justify-content-center aling-items-center flex-row">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="register-btn"
              >
                <span> Get Started</span>
              </Button>
            </FormGroup>
          </form>
          {/* <div className="d-flex justify-content-center align-items-center">
            <p>
              Have an account?
              <Link to={"/login"} className="sign-up">
                {" "}
                Login
              </Link>
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default ClientUserRegister;
